<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body" v-if="!packageList.length">
      無套餐，請新增
    </div>
    <div class="box-body" v-else>
      <div class="col-xs-12">
        <div class="inline-block pull-left">
          <h4 class="pull-left">
          套餐
          </h4>
        </div>
        <div>
          <button class="btn btn-danger m-y-10 inline-block pull-right" data-toggle="modal" data-target="#delModal" @click="delModalOpen">
            刪除
          </button>
          <button
            class="btn btn-default btn-black m-y-10 inline-block pull-right m-r-10"
            @click="gotoCrPackages"
          >
            新增
          </button>
          <button class="btn btn-default btn-black m-y-10 inline-block pull-right m-r-10" data-toggle="modal" @click="show.easy = !show.easy">
            <span v-if="!show.easy">簡易</span>
            <span v-else>進階</span>
          </button>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="col-xs-12 col-md-2 text-left">
          <div class="bg-light-gray select-element-block " style="max-height: calc(100vh - 396px); margin-left: 0px; margin-right: 0px; width: 100%">
            <div class="select-element" v-for="(package, index) in packageList" :class="{'active': curId === package.item_id}" @click="clickPackage(package, index)" :disabled="isLoad || curId === package.item_id">
              <span class="text-w-600">{{package.name}}</span> <small style="opacity: .7;">&nbsp;&nbsp;{{package.remark}}</small>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-10">
          <div class="box-body form menu-form col-xs-12">
            <div class="col-xs-12 col-md-6 p-r-5">
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>套餐名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="packageInfo.name" maxlength="32">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>排<div class="inline-block w-35"></div>序</span>
                <input class="form-control" placeholder="" type="text" v-model="packageInfo.sort" @keyup="veritySort" maxlength="4"ref="sort">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>價<div class="inline-block w-35"></div>格</span>
                <input class="form-control" placeholder="" type="text" v-model="packageInfo.price" @keyup="verityPrice()" maxlength="9" ref="price">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>選購數量<br></span>
                <input style="width: calc(50% - 10px)" class="c-auto form-control" placeholder="0為無上限" type="text" @keyup="verityMinLimit()" v-model="packageInfo.min_limit" maxlength="9" ref="minLimit">
                <span class="pull-left" style="line-height: 38px; width: 20px">~</span>
                <input style="width: calc(50% - 10px)"  class="c-auto form-control" placeholder="0為無上限" type="text" @keyup="verityMaxLimit()" v-model="packageInfo.max_limit" maxlength="9" ref="maxLimit">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">備<div class="inline-block w-35"></div>註</span>
                <input class="form-control" placeholder="" type="text" v-model="packageInfo.remark" maxlength="45">
              </div>
              <br />
            </div>
            <div class="col-xs-12 col-md-6 p-l-5" v-show="!show.easy">
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>價格類型</span>
                <div class="form-group">
                  <select class="form-control" v-model="packageInfo.price_type" >
                    <option :value="1">免稅價格</option>
                    <option :value="3">含稅價格</option>
                  </select>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">描<div class="inline-block w-35"></div>述</span>
                <input class="form-control" placeholder="" type="text" v-model="packageInfo.description" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">商品料號</span>
                <input class="form-control" placeholder="" type="text" v-model="packageInfo.vendor_custom_id" maxlength="30">
              </div>
              <br />
            </div>
            <div class="col-xs-12">
              <div class="input-group">
                <span class="input-group-addon">選擇區</span>
                <div class="form-control text-left" style="min-height: 60px">
                  <button class="btn btn-default btn-black m-y-10 inline-block " data-toggle="modal" data-target="#choseModal" style="position: absolute; right: 10px; top: 0px; z-index: 3;">
                    選擇選擇區
                  </button>
                  <div class="option-left-block">
                    <div class="inline-block m-r-10 option-chose" v-for="block in blockList" style="margin: 5px" v-if="block.active">
                      {{block.name}}
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-footer text-center">
      <button class="btn btn-default" @click="gotoOut">
        返回
      </button>
      <button
        v-if="!packageList.length"
        class="btn btn-default btn-black"
        @click="gotoCrPackages"
      >
        新增
      </button>
      <button class="btn btn-success" @click="checkInputEmpty" v-else>
        儲存
      </button>
    </div>
    <br />
    <c-modal :elementList="blockList" :option="choseOption" @trigger="trigger"></c-modal>
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>

<script>
import matcherModal from '../../../elements/Modal.vue'
import $ from 'jquery'
import AdjustModal from './AdjustModal.vue'
import OptionModal from './OptionModal.vue'
import { mapActions, mapGetters } from 'vuex'
import ChoseModal from '../../../elements/ChooseModal.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'CrPackageTemp',
  extends: NdExtendHandleMenu,
  components: {
    'adjust-modal': AdjustModal,
    'option-modal': OptionModal,
    'c-modal': ChoseModal,
    'm-modal': matcherModal
  },
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },
      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },
      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },
      count: 20,
      maxTotal: 0,
      categoryList: [
        {label: '愛茶的牛', val: 1},
        {label: '茶類', val: 2},
        {label: '鮮奶類', val: 3},
        {label: '小餐點', val: 4},
        {label: '點心', val: 5},
        {label: '套餐', val: 6},
        {label: '單點', val: 7},
        {label: '無酒精類', val: 8},
        {label: '比薩', val: 9},
        {label: '鮮果汁', val: 10},
        {label: '未分類', val: 11}
      ],
      packageList: [],
      adjustList: [
        {name: '尺寸'},
        {name: '尺寸'},
        {name: '甜度'},
        {name: '甜度'},
        {name: '冰度'},
        {name: '冰度'},
        {name: '冰度'},
        {name: '冰度'},
        {name: '配料'},
        {name: '加料'},
        {name: '配料'}
      ],
      blockList: [],
      optionList: [
        {name: '布丁', id: 1, active: false, remark: '加料1用'},
        {name: '燒仙草', id: 2, active: false, remark: '加料2用'},
        {name: '仙人掌珍珠', id: 3, active: false, remark: ''},
        {name: '波霸', id: 4, active: false, remark: ''},
        {name: '黑糖珍珠', id: 5, active: false, remark: '加料3用'},
        {name: '椰果', id: 6, active: false, remark: ''},
        {name: '珍珠', id: 7, active: false, remark: '加料1用'}
      ],
      packageInfo: {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: 0,
        price_type: '3',
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      },
      choseOption: {
        // 配料modal資料
        id: 'choseModal',
        title: '選擇選擇區',
        event: 'chooseElement'
      },
      select: {
        category: ''
      },
      curId: 0,
      oldInfo: {},
      defaultIndex: 1,
      isLoad: false,
      delOption: {
        id: 'delModal',
        title: '刪除套餐',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'del'
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['setUpAdjust', 'setModal']),
    toggle () {
      $(this.$refs.infoAdjustModal).css('display')
    },
    maxAmount (max) {
      if (!max) return '無限制'
      else return max
    },
    getSubType (type) {
      if (type === 10) {
        return '大小'
      } else if (type === 20) {
        return '容器'
      } else if (type === 30) {
        return '甜度'
      } else if (type === 40) {
        return '溫度'
      } else {
        return '其他'
      }
    },
    getPriceType (type) {
      if (type === 1) return '免稅價格'
      else if (type === 3) return '含稅價格'
    },
    veritySort () {
      var e = $(this.$refs.sort)
      this.packageInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMinLimit () {
      var e = $(this.$refs.minLimit)
      this.packageInfo.min_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityMaxLimit () {
      var e = $(this.$refs.maxLimit)
      this.packageInfo.max_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityPrice () {
      var e = $(this.$refs.price)
      this.packageInfo.price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    verityCalorie () {
      var e
      if (this.state === 1) e = $(this.$refs.calorie1)
      else if (this.state === 3) e = $(this.$refs.calorie3)
      this.packageInfo.calorie = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    checkInputEmpty () {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫套餐名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.min_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最低購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.max_limit) {
        this.$notify({
          title: '提醒',
          text: '請填寫最高購買數',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.upPackage()
        return true
      }
    },
    delAdjust () {
      const url = this.base + this.id + '/adjust?adjust_id=' + this.adjustId
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功刪除調整類別',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.editState = false
          const id = this.modalId
          $('#' + id).modal('toggle')
          this.setUpAdjust(true)
        }
      })
    },
    clearData () {
      this.packageInfo = {
        name: '',
        sort: 1,
        description: '',
        remark: '',

        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      }
    },
    gotoCrPackages () {
      console.log('gotoCrPackages')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuPackageCreate'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'crPackages'
      }

      this.$router.push({ name, params })
    },
    gotoOut () {
      this.$router.go(-1)
    },
    gotoNext () {
      this.$router.push('/upCategory/' + this.brandId)
    },
    trigger (event) {
      if (event === 'del') {
        this.del(this.packageInfo.name)
      }
    },
    del (delName) {
      const url = this.base + this.id + '/package?package_id=' + this.packageInfo.package_id
      this.getDataH('delete', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getAllMenuPackage('delete')
        }
      })
    },
    getMenuCategory () {
      const url = this.base + this.id + '/category/briefList'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const categoryList = response.data.list
          this.categoryList = categoryList
          const select = {
            name: '未分類',
            item_id: 0
          }
          this.categoryList.push(select)
          if (!this.select.category) this.select.category = categoryList[0].item_id
        }
      })
    },
    getAllMenuPackage (type) {
      this.packageList = []
      const url = this.base + this.id + '/package/briefList?type=0'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const categoryList = response.data.list
          categoryList.forEach((c) => {
            let pList = c.child_list
            pList.forEach((p) => {
              this.$set(p, 'active', false)
              this.packageList.push(p)
            })
          })
          if ((this.packageList.length && !this.curId) || type === 'delete') {
            if (this.$route.query.cId) this.curId = parseInt(this.$route.query.cId, 10)
            else this.curId = this.packageList[0].item_id
          }
          this.getMenuBlock()
        }
      })
    },
    getPackage () {
      this.packageInfo.sort = 0
      const url = this.base + this.id + '/package/' + this.curId
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          $.each(response.data.package, (index, value) => {
            this.$set(this.oldInfo, index, value)
          })
          this.packageInfo = response.data.package
          if (!this.packageInfo.sort) {
            this.packageInfo.sort = this.defaultIndex
            this.packageInfo.price = 0
            this.upPackage('sort')
          }
          this.setActiveBlock()
        }
      })
    },
    setActiveBlock () {
      if (this.packageInfo.block_list.length) {
        const cList = this.packageInfo.block_list
        cList.forEach((e) => {
          const block = {
            active: true,
            description: e.description,
            item_id: e.block_id,
            name: e.name,
            price: e.price,
            remark: e.remark,
            vendor_custom_id: e.vendor_custom_id
          }
          this.blockList.push(block)
          this.isLoad = false
        })
      } else {
        this.isLoad = false
      }
    },
    upPackage (type) {
      const url = this.base + this.id + '/package/' + this.curId
      let data = {}
      let pInfo = this.packageInfo
      let oldInfo = this.oldInfo
      if (type === 'sort') {
        data.sort = pInfo.sort
        data.price = pInfo.price
      } else {
        let newPList = []
        this.blockList.forEach((element) => {
          if (element.active) newPList.push(element.item_id)
        })
        let bList = []
        pInfo.block_list.forEach((element) => {
          bList.push(element.block_id)
        })
        if (pInfo.sort !== oldInfo.sort) data.sort = pInfo.sort
        if (pInfo.name !== oldInfo.name) data.name = pInfo.name
        if (pInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = pInfo.vendor_custom_id
        if (pInfo.description !== oldInfo.description) data.description = pInfo.description
        if (pInfo.remark !== oldInfo.remark) data.remark = pInfo.remark
        data.price = pInfo.price
        if (pInfo.price_type !== oldInfo.price_type) data.price_type = pInfo.price_type
        if (pInfo.min_limit !== oldInfo.min_limit) data.min_limit = pInfo.min_limit
        if (pInfo.max_limit !== oldInfo.max_limit) data.max_limit = pInfo.max_limit
        if (JSON.stringify(newPList) !== JSON.stringify(bList)) {
          data.block_list = newPList
        }
      }
      if (!data.price && data.price !== 0) data.price = null
      if (JSON.stringify(data) !== '{}') {
        this.getDataH('put', url, data, (response) => {
          if (response.data.status === 200) {
            if (!type) {
              this.$notify({
                title: '提醒',
                text: '已更新' + pInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              })
            }
            if (pInfo.name !== oldInfo.name) {
              this.getMenuBlock('reload', pInfo.block_id)
            }
          }
        })
      }
    },
    getMenuBlock () {
      this.blockList = []
      const url = this.base + this.id + '/block/briefList?type=2'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            const categoryList = response.data.list
            categoryList.forEach((element) => {
              const blockList = element.child_list
              blockList.forEach((element) => {
                this.$set(element, 'active', false)
                this.blockList.push(element)
              })
            })
            this.getPackage()
          } else if (this.curId) this.getPackage()
        }
      })
    },
    clickPackage (p, index) {
      this.isLoad = true
      this.curId = p.item_id
      this.defaultIndex = index + 1
      this.getMenuBlock()
    },
    delModalOpen () {
      this.delOption.title = `刪除${this.packageInfo.name}`
    }
  },
  created () {
    this.getAllMenuPackage()
  },
  computed: {
    ...mapGetters(['getUpAdjust', 'getModal', 'getRoleType']),
    allInput () {
      return {
        name: this.checkInput(this.packageInfo.name),
        sort: this.checkInput(this.packageInfo.sort),
        vendor_custom_id: this.checkInput(this.packageInfo.adjust_custom_id),
        description: this.checkInput(this.packageInfo.description),
        remark: this.checkInput(this.packageInfo.remark),
        price: this.checkInput(this.packageInfo.price),
        calorie: this.checkInput(this.packageInfo.calorie),
        min_limit: this.checkInput(this.packageInfo.min_limit),
        max_limit: this.checkInput(this.packageInfo.max_limit)
      }
    },
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    productNew () {
      var product = this.product
      return product
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    }
  }
}
</script>

<style lang="sass" scoped>
$light-gray: rgb(238, 238, 238)
$primary-color: #3c8dbc

.btn-black, .btn-black:hover, .btn-black:focus, .btn-black:active, .btn-black:active:focus
  border: 1px solid #333333
.m-r-10
  margin-right: 10px
.p-r-5
  padding-right: 5px
.p-l-5
  padding-left: 5px
.box-body.menu-form
  left: 0
  width: auto
  padding: 0px 10px
.btn.disabled, .btn[disabled], fieldset[disabled] .btn
  cursor: auto
  opacity: 1
.bg-light-gray
  background: $light-gray
.select-element
  padding: 10px 15px
  cursor: pointer
  border-bottom: 2px solid #ddd
.select-element:last-child
  border-bottom: 0px
.select-element:hover, .select-element.active
  background: $primary-color
  color: #fff
.select-element-block
  margin-bottom: 10px
  max-height: calc(100vh - 360px)
  overflow: scroll
.option-chose
  background: $primary-color
  color: #ffffff
  padding: 6px 12px
.option-left-block
  width: calc(100% - 95px)
@media screen and (max-width: 767px)
  .select-element
    padding: 5px 15px
    font-size: 16px
  .select-element-block
    margin-left: 10px
    margin-right: 10px
    height: 30vh
  .option-left-block
    width: 100%
    padding-top: 45px
</style>




// WEBPACK FOOTER //
// CrPackageTemp.vue?2947fe36